export const HEADER_HEIGHT = 43;
export const LEFT_SIDEBAR_PANEL_WIDTH = 264;
export const RIGHT_SIDEBAR_TRAY_WIDTH = 42;
export const RIGHT_SIDEBAR_PANEL_WIDTH = 320;
